"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceUnavailableError = void 0;
const BaseError_1 = require("./BaseError");
class ServiceUnavailableError extends BaseError_1.BaseError {
    constructor(description = "Service Temporarily Unavailable") {
        super("ServiceUnavailableError", 503, description, true);
    }
}
exports.ServiceUnavailableError = ServiceUnavailableError;
